(function ($, Drupal, once) {
  'use strict';
  Drupal.behaviors.componentImageSplit = {
    attach: function (context, settings) {
      function startMessengerChat() {
        // eslint-disable-next-line
        astuteBotMessenger.sendEvent({name: 'Bot', index: 0}, {autoGetStarted: true, forceNewSession: true, persistConversationAcrossSession: true, initialUserMessage: {type: 'event', content: {type: 0}}});
      }

      $('.component-image-split.enable-chat:not(.initialized)', context).each(function (index) {
        $(this).addClass('initialized');
        const $targetButton = $(this).find('.field--name-field-cta .field__item a').filter(function () {
          return $(this).text().toLowerCase().includes('chat');
        });
        $targetButton.click(function (event) {
          event.preventDefault();
          startMessengerChat();
          return false;
        });
      });

      // Create video modal and event listeners
      if ('videoPlayer' in drupalSettings) {
        once('componentImageSplit', '.paragraph--type-image-split', context).forEach(function (element) {
          $(element).addClass('video-initialized');
          var paragraphId = $(element).attr('id').replace('-', '_');
          var playerInfo = drupalSettings.videoPlayer[paragraphId];
          if (typeof playerInfo === 'undefined') {
            return;
          }
          var modalId = $(element).attr('id').replace('paragraph-', 'modal-');
          var modal = $(element).find('.video-player__modal').attr('data-modal', modalId);
          var closeButton = $(element).find('.video-player__modal-close-button').attr('data-modal', modalId);
          var videoPlayerPlayButton = $(element).find('.video-player__play-button');
          if (playerInfo.video_provider === 'youtube') {
            var playerId = $(element).attr('id').replace('paragraph-', 'player_');
            var videoPlayerContainer = $(element).find('.video-player__video-container');
            videoPlayerContainer.attr('id', playerId);
            // This function creates an <iframe> (and YouTube player)
            // after the API code downloads.
            var player;

            // eslint-disable-next-line no-inner-declarations
            function onYouTubeIframeAPIReady() {
              // eslint-disable-next-line no-undef
              player = new YT.Player('' + playerId + '', {
                height: playerInfo.video_height,
                width: playerInfo.video_width,
                videoId: playerInfo.video_id,
                events: {
                  onReady: onPlayerReady, // eslint-disable-line
                },
                host: `${window.location.protocol}//www.youtube.com`
              });
            }

            // eslint-disable-next-line no-inner-declarations
            function onPlayerReady(event) {
              // bind events
              videoPlayerPlayButton.bind('click', function () {
                modal.css('display', 'flex');
                player.playVideo();
              });
            }

            window.YT.ready(function () {
              onYouTubeIframeAPIReady();
            });
            closeButton.bind('click', function () {
              modal.css('display', 'none');
              player.stopVideo();
              player.destroy();
              player = null;
              onYouTubeIframeAPIReady();
            });
            modal.bind('click', function () {
              if (modal.css('display') === 'flex') {
                modal.css('display', 'none');
                player.stopVideo();
                player.destroy();
                player = null;
                onYouTubeIframeAPIReady();
              }
            });
          }
          else if (playerInfo.video_provider === 'vimeo') {
            var vimeoPlayerId = $(element).attr('id').replace('paragraph-', 'player_');
            var vimeoVideoPlayerPlayButton = $(element).find('.video-player__play-button');
            var vimeoVideoPlayerContainer = $(element).find('.video-player__video-container');
            vimeoVideoPlayerContainer.find('iframe').attr('id', vimeoPlayerId);
            var vimeoIframe = $('#' + vimeoPlayerId + '')[0];
            // eslint-disable-next-line no-undef
            var vimeoPlayer = new Vimeo.Player(vimeoIframe);
            vimeoVideoPlayerPlayButton.bind('click', function () {
              modal.css('display', 'flex');
            });
            closeButton.bind('click', function () {
              modal.css('display', 'none');
              vimeoPlayer.pause();
              vimeoPlayer.unload();
            });
          }
        });
      }
    }
  };
})(jQuery, Drupal, once);
